module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/zw-2840e62aaca37d36b327f560b9557df1.svg";